/** Shared style constants for the admin dashboard screens. */
export const CARD_SHADOW = '0px 2px 8px rgba(0,0,0,0.04)'
export const CARD_RADIUS = '16px'
export const SECTION_RADIUS = '18px'
export const PILL_RADIUS = '999px'
export const INPUT_RADIUS = '10px'

/** Status literals already used across the dashboard. */
export const STATUS_GREEN = '#15803D'
export const STATUS_RED = '#991B1B'
export const STATUS_AMBER = '#B45309'
export const STATUS_BLUE = '#1D4ED8'
export const STATUS_GOLD = '#D6B97B'
